import { AppDefaultNavigationState } from '../../../initialStateRegistration';

export const getFooter = (state: AppDefaultNavigationState) => state.footer;
